module.exports = {
      id: "vikatan-play-usage",
      viewBox: "0 0 27.8 28.8",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#vikatan-play",
      toString: function () {
        return this.url;
      }
    }